import React from 'react';
import { Route, Switch } from 'react-router';
import List from './List';

class FAQ extends React.Component {
    render() {
        return (
            <Switch>
                <Route path='/clientChat/faq' component={List}/>
            </Switch>
        )
    }
}

export default FAQ;



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/FAQ/Normal/index.js